// Simplified Catalan text analysis component - only Word Categories (no pragmatics, phrasal verbs, or verb tenses yet)
import { useEffect, useState } from 'react';
import { Accordion, Alert, Form } from 'react-bootstrap';
import parse from "html-react-parser";
import { registerNlpStart } from '../../utils/utils';
import { useTranslation } from 'react-i18next';

export interface AnalyzedTextProps {
    task_id: string;
    analyzedText: any;
    saveFormattedTextCallback: CallableFunction;
    language?: string;
}

export default function AnalyzedTextCatalan(props: AnalyzedTextProps) {
    const { t } = useTranslation();

    console.log('props.analyzedText', props.analyzedText);

    const [allText, setAllText] = useState('');
    const [processingEmpty, setProcessingEmpty] = useState(false);

    const [nlpCategories, setNlpCategories] = useState<any>({});

    const [nounsFilterActive, setNounsFilterActive] = useState(false);
    const [nounsFilterOption, setNounsFilterOption] = useState('all');
    const [nounsColor, setNounsColor] = useState('');
    const [nounsSize, setNounsSize] = useState('');
    const [nounsBold, setNounsBold] = useState(false);
    const [nounsItalic, setNounsItalic] = useState(false);
    const [nounsUnderline, setNounsUnderline] = useState(false);

    const [adjectivesFilterActive, setAdjectivesFilterActive] = useState(false);
    const [adjectivesFilterOption, setAdjectivesFilterOption] = useState('all');
    const [adjectivesColor, setAdjectivesColor] = useState('');
    const [adjectivesSize, setAdjectivesSize] = useState('');
    const [adjectivesBold, setAdjectivesBold] = useState(false);
    const [adjectivesItalic, setAdjectivesItalic] = useState(false);
    const [adjectivesUnderline, setAdjectivesUnderline] = useState(false);

    const [adverbsFilterActive, setAdverbsFilterActive] = useState(false);
    const [adverbsFilterOption, setAdverbsFilterOption] = useState('all');
    const [adverbsColor, setAdverbsColor] = useState('');
    const [adverbsSize, setAdverbsSize] = useState('');
    const [adverbsBold, setAdverbsBold] = useState(false);
    const [adverbsItalic, setAdverbsItalic] = useState(false);
    const [adverbsUnderline, setAdverbsUnderline] = useState(false);

    const [verbsFilterActive, setVerbsFilterActive] = useState(false);
    const [verbsFilterOption, setVerbsFilterOption] = useState('all');
    const [verbsColor, setVerbsColor] = useState('');
    const [verbsSize, setVerbsSize] = useState('');
    const [verbsBold, setVerbsBold] = useState(false);
    const [verbsItalic, setVerbsItalic] = useState(false);
    const [verbsUnderline, setVerbsUnderline] = useState(false);

    const [prepositionsFilterActive, setPrepositionsFilterActive] = useState(false);
    const [prepositionsFilterOption, setPrepositionsFilterOption] = useState('all');
    const [prepositionsColor, setPrepositionsColor] = useState('');
    const [prepositionsSize, setPrepositionsSize] = useState('');
    const [prepositionsBold, setPrepositionsBold] = useState(false);
    const [prepositionsItalic, setPrepositionsItalic] = useState(false);
    const [prepositionsUnderline, setPrepositionsUnderline] = useState(false);

    const [subConjunctionsFilterActive, setSubConjunctionsFilterActive] = useState(false);
    const [subConjunctionsFilterOption, setSubConjunctionsFilterOption] = useState('all');
    const [subConjunctionsColor, setSubConjunctionsColor] = useState('');
    const [subConjunctionsSize, setSubConjunctionsSize] = useState('');
    const [subConjunctionsBold, setSubConjunctionsBold] = useState(false);
    const [subConjunctionsItalic, setSubConjunctionsItalic] = useState(false);
    const [subConjunctionsUnderline, setSubConjunctionsUnderline] = useState(false);

    const [determinersFilterActive, setDeterminersFilterActive] = useState(false);
    const [determinersFilterOption, setDeterminersFilterOption] = useState('all');
    const [determinersColor, setDeterminersColor] = useState('');
    const [determinersSize, setDeterminersSize] = useState('');
    const [determinersBold, setDeterminersBold] = useState(false);
    const [determinersItalic, setDeterminersItalic] = useState(false);
    const [determinersUnderline, setDeterminersUnderline] = useState(false);

    const [pronounsFilterActive, setPronounsFilterActive] = useState(false);
    const [pronounsFilterOption, setPronounsFilterOption] = useState('all');
    const [pronounsColor, setPronounsColor] = useState('');
    const [pronounsSize, setPronounsSize] = useState('');
    const [pronounsBold, setPronounsBold] = useState(false);
    const [pronounsItalic, setPronounsItalic] = useState(false);
    const [pronounsUnderline, setPronounsUnderline] = useState(false);

    const [conjunctionsFilterActive, setConjunctionsFilterActive] = useState(false);
    const [conjunctionsFilterOption, setConjunctionsFilterOption] = useState('all');
    const [conjunctionsColor, setConjunctionsColor] = useState('');
    const [conjunctionsSize, setConjunctionsSize] = useState('');
    const [conjunctionsBold, setConjunctionsBold] = useState(false);
    const [conjunctionsItalic, setConjunctionsItalic] = useState(false);
    const [conjunctionsUnderline, setConjunctionsUnderline] = useState(false);

    const handleNounsFilterChange = (event) => {
        setNounsColor('');
        setNounsSize('');
        setNounsBold(false);
        setNounsItalic(false);
        setNounsUnderline(false);
        setNounsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            'all', '', '', false, false, false,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleNounsFilterOptionChange = (event) => {
        setNounsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Nouns', event.target.value);
        formatText(props.analyzedText.main,
            event.target.value, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleAdjectivesFilterChange = (event) => {
        setAdjectivesColor('');
        setAdjectivesSize('');
        setAdjectivesBold(false);
        setAdjectivesItalic(false);
        setAdjectivesUnderline(false);
        setAdjectivesFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            'all', '', '', false, false, false,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleAdjectivesFilterOptionChange = (event) => {
        setAdjectivesFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Adjectives', event.target.value);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            event.target.value, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleAdverbsFilterChange = (event) => {
        setAdverbsColor('');
        setAdverbsSize('');
        setAdverbsBold(false);
        setAdverbsItalic(false);
        setAdverbsUnderline(false);
        setAdverbsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            'all', '', '', false, false, false,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleAdverbsFilterOptionChange = (event) => {
        setAdverbsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Adverbs', event.target.value);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            event.target.value, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleVerbsFilterChange = (event) => {
        setVerbsColor('');
        setVerbsSize('');
        setVerbsBold(false);
        setVerbsItalic(false);
        setVerbsUnderline(false);
        setVerbsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            'all', '', '', false, false, false,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleVerbsFilterOptionChange = (event) => {
        setVerbsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Verbs', event.target.value);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            event.target.value, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handlePrepositionsFilterChange = (event) => {
        setPrepositionsColor('');
        setPrepositionsSize('');
        setPrepositionsBold(false);
        setPrepositionsItalic(false);
        setPrepositionsUnderline(false);
        setPrepositionsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            'all', '', '', false, false, false,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handlePrepositionsFilterOptionChange = (event) => {
        setPrepositionsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Preposition', event.target.value);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            event.target.value, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleSubConjunctionsFilterChange = (event) => {
        setSubConjunctionsColor('');
        setSubConjunctionsSize('');
        setSubConjunctionsBold(false);
        setSubConjunctionsItalic(false);
        setSubConjunctionsUnderline(false);
        setSubConjunctionsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            'all', '', '', false, false, false,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleSubConjunctionsFilterOptionChange = (event) => {
        setSubConjunctionsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'SubConjunction', event.target.value);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            event.target.value, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleDeterminersFilterChange = (event) => {
        setDeterminersColor('');
        setDeterminersSize('');
        setDeterminersBold(false);
        setDeterminersItalic(false);
        setDeterminersUnderline(false);
        setDeterminersFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            'all', '', '', false, false, false,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleDeterminersFilterOptionChange = (event) => {
        setDeterminersFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Determiners', event.target.value);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            event.target.value, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handlePronounsFilterChange = (event) => {
        setPronounsColor('');
        setPronounsSize('');
        setPronounsBold(false);
        setPronounsItalic(false);
        setPronounsUnderline(false);
        setPronounsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            'all', '', '', false, false, false,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handlePronounsFilterOptionChange = (event) => {
        setPronounsFilterOption(event.target.value);
        registerNlpStart(props.task_id, 'Word Categories', 'Pronouns', event.target.value);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            event.target.value, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const handleConjunctionsFilterChange = (event) => {
        setConjunctionsColor('');
        setConjunctionsSize('');
        setConjunctionsBold(false);
        setConjunctionsItalic(false);
        setConjunctionsUnderline(false);
        setConjunctionsFilterActive(event.target.checked);
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            'all', '', '', false, false, false);
    }

    const setColor = (event: any) => {
        registerNlpStart(props.task_id, 'Color', event.target.dataset.element, event.target.dataset.color);
        let newNounsColor = nounsColor;
        let newAdjectivesColor = adjectivesColor;
        let newAdverbsColor = adverbsColor;
        let newVerbsColor = verbsColor;
        let newPrepositionsColor = prepositionsColor;
        let newSubConjunctionsColor = subConjunctionsColor;
        let newDeterminersColor = determinersColor;
        let newPronounsColor = pronounsColor;
        let newConjunctionsColor = conjunctionsColor;
        switch (event.target.dataset.element) {
            case 'noun':
                setNounsColor(event.target.dataset.color);
                newNounsColor = event.target.dataset.color;
                break;
            case 'adjective':
                setAdjectivesColor(event.target.dataset.color);
                newAdjectivesColor = event.target.dataset.color;
                break;
            case 'adverb':
                setAdverbsColor(event.target.dataset.color);
                newAdverbsColor = event.target.dataset.color;
                break;
            case 'verb':
                setVerbsColor(event.target.dataset.color);
                newVerbsColor = event.target.dataset.color;
                break;
            case 'preposition':
                setPrepositionsColor(event.target.dataset.color);
                newPrepositionsColor = event.target.dataset.color;
                break;
            case 'subconjunction':
                setSubConjunctionsColor(event.target.dataset.color);
                newSubConjunctionsColor = event.target.dataset.color;
                break;
            case 'determiner':
                setDeterminersColor(event.target.dataset.color);
                newDeterminersColor = event.target.dataset.color;
                break;
            case 'pronoun':
                setPronounsColor(event.target.dataset.color);
                newPronounsColor = event.target.dataset.color;
                break;
            case 'conjunctions':
                setConjunctionsColor(event.target.dataset.color);
                newConjunctionsColor = event.target.dataset.color;
                break;
        }
        formatText(props.analyzedText.main,
            nounsFilterOption, newNounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, newAdjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, newAdverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, newVerbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, newPrepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, newSubConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, newDeterminersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, newPronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, newConjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const setSize = (event: any) => {
        registerNlpStart(props.task_id, 'Size', event.target.dataset.element, event.target.dataset.size);
        let newNounsSize = nounsSize;
        let newAdjectivesSize = adjectivesSize;
        let newAdverbsSize = adverbsSize;
        let newVerbsSize = verbsSize;
        let newPrepositionsSize = prepositionsSize;
        let newSubConjunctionsSize = subConjunctionsSize;
        let newDeterminersSize = determinersSize;
        let newPronounsSize = pronounsSize;
        let newConjunctionsSize = conjunctionsSize;
        switch (event.target.dataset.element) {
            case 'noun':
                setNounsSize(event.target.dataset.size);
                newNounsSize = event.target.dataset.size;
                break;
            case 'adjective':
                setAdjectivesSize(event.target.dataset.size);
                newAdjectivesSize = event.target.dataset.size;
                break;
            case 'adverb':
                setAdverbsSize(event.target.dataset.size);
                newAdverbsSize = event.target.dataset.size;
                break;
            case 'verb':
                setVerbsSize(event.target.dataset.size);
                newVerbsSize = event.target.dataset.size;
                break;
            case 'preposition':
                setPrepositionsSize(event.target.dataset.size);
                newPrepositionsSize = event.target.dataset.size;
                break;
            case 'subconjunction':
                setSubConjunctionsSize(event.target.dataset.size);
                newSubConjunctionsSize = event.target.dataset.size;
                break;
            case 'determiner':
                setDeterminersSize(event.target.dataset.size);
                newDeterminersSize = event.target.dataset.size;
                break;
            case 'pronoun':
                setPronounsSize(event.target.dataset.size);
                newPronounsSize = event.target.dataset.size;
                break;
            case 'conjunctions':
                setConjunctionsSize(event.target.dataset.size);
                newConjunctionsSize = event.target.dataset.size;
                break;
        }
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, newNounsSize, nounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, newAdjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, newAdverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, newVerbsSize, verbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, newPrepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, newSubConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, newDeterminersSize, determinersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, newPronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, newConjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const setBold = (event: any) => {
        registerNlpStart(props.task_id, 'Bold', event.target.dataset.element, (!event.target.classList.contains('active')).toString());
        let newNounsBold = nounsBold;
        let newAdjectivesBold = adjectivesBold;
        let newAdverbsBold = adverbsBold;
        let newVerbsBold = verbsBold;
        let newPrepositionsBold = prepositionsBold;
        let newSubConjunctionsBold = subConjunctionsBold;
        let newDeterminersBold = determinersBold;
        let newPronounsBold = pronounsBold;
        let newConjunctionsBold = conjunctionsBold;
        switch (event.target.dataset.element) {
            case 'noun':
                setNounsBold(!event.target.classList.contains('active'));
                newNounsBold = !event.target.classList.contains('active');
                break;
            case 'adjective':
                setAdjectivesBold(!event.target.classList.contains('active'));
                newAdjectivesBold = !event.target.classList.contains('active');
                break;
            case 'adverb':
                setAdverbsBold(!event.target.classList.contains('active'));
                newAdverbsBold = !event.target.classList.contains('active');
                break;
            case 'verb':
                setVerbsBold(!event.target.classList.contains('active'));
                newVerbsBold = !event.target.classList.contains('active');
                break;
            case 'preposition':
                setPrepositionsBold(!event.target.classList.contains('active'));
                newPrepositionsBold = !event.target.classList.contains('active');
                break;
            case 'subconjunction':
                setSubConjunctionsBold(!event.target.classList.contains('active'));
                newSubConjunctionsBold = !event.target.classList.contains('active');
                break;
            case 'determiner':
                setDeterminersBold(!event.target.classList.contains('active'));
                newDeterminersBold = !event.target.classList.contains('active');
                break;
            case 'pronoun':
                setPronounsBold(!event.target.classList.contains('active'));
                newPronounsBold = !event.target.classList.contains('active');
                break;
            case 'conjunctions':
                setConjunctionsBold(!event.target.classList.contains('active'));
                newConjunctionsBold = !event.target.classList.contains('active');
                break;
        }
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, newNounsBold, nounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, newAdjectivesBold, adjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, newAdverbsBold, adverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, newVerbsBold, verbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, newPrepositionsBold, prepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, newSubConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, newDeterminersBold, determinersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, newPronounsBold, pronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, newConjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
    }

    const setItalic = (event: any) => {
        registerNlpStart(props.task_id, 'Italic', event.target.dataset.element, (!event.target.classList.contains('active')).toString());
        let newNounsItalic = nounsItalic;
        let newAdjectivesItalic = adjectivesItalic;
        let newAdverbsItalic = adverbsItalic;
        let newVerbsItalic = verbsItalic;
        let newPrepositionsItalic = prepositionsItalic;
        let newSubConjunctionsItalic = subConjunctionsItalic;
        let newDeterminersItalic = determinersItalic;
        let newPronounsItalic = pronounsItalic;
        let newConjunctionsItalic = conjunctionsItalic;
        switch (event.target.dataset.element) {
            case 'noun':
                setNounsItalic(!event.target.classList.contains('active'));
                newNounsItalic = !event.target.classList.contains('active');
                break;
            case 'adjective':
                setAdjectivesItalic(!event.target.classList.contains('active'));
                newAdjectivesItalic = !event.target.classList.contains('active');
                break;
            case 'adverb':
                setAdverbsItalic(!event.target.classList.contains('active'));
                newAdverbsItalic = !event.target.classList.contains('active');
                break;
            case 'verb':
                setVerbsItalic(!event.target.classList.contains('active'));
                newVerbsItalic = !event.target.classList.contains('active');
                break;
            case 'preposition':
                setPrepositionsItalic(!event.target.classList.contains('active'));
                newPrepositionsItalic = !event.target.classList.contains('active');
                break;
            case 'subconjunction':
                setSubConjunctionsItalic(!event.target.classList.contains('active'));
                newSubConjunctionsItalic = !event.target.classList.contains('active');
                break;
            case 'determiner':
                setDeterminersItalic(!event.target.classList.contains('active'));
                newDeterminersItalic = !event.target.classList.contains('active');
                break;
            case 'pronoun':
                setPronounsItalic(!event.target.classList.contains('active'));
                newPronounsItalic = !event.target.classList.contains('active');
                break;
            case 'conjunctions':
                setConjunctionsItalic(!event.target.classList.contains('active'));
                newConjunctionsItalic = !event.target.classList.contains('active');
                break;
        }
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, newNounsItalic, nounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, newAdjectivesItalic, adjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, newAdverbsItalic, adverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, newVerbsItalic, verbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, newPrepositionsItalic, prepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, newSubConjunctionsItalic, subConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, newDeterminersItalic, determinersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, newPronounsItalic, pronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, newConjunctionsItalic, conjunctionsUnderline);
    }

    const setUnderline = (event: any) => {
        registerNlpStart(props.task_id, 'Underline', event.target.dataset.element, (!event.target.classList.contains('active')).toString());
        let newNounsUnderline = nounsUnderline;
        let newAdjectivesUnderline = adjectivesUnderline;
        let newAdverbsUnderline = adverbsUnderline;
        let newVerbsUnderline = verbsUnderline;
        let newPrepositionsUnderline = prepositionsUnderline;
        let newSubConjunctionsUnderline = subConjunctionsUnderline;
        let newDeterminersUnderline = determinersUnderline;
        let newPronounsUnderline = pronounsUnderline;
        let newConjunctionsUnderline = conjunctionsUnderline;
        switch (event.target.dataset.element) {
            case 'noun':
                setNounsUnderline(!event.target.classList.contains('active'));
                newNounsUnderline = !event.target.classList.contains('active');
                break;
            case 'adjective':
                setAdjectivesUnderline(!event.target.classList.contains('active'));
                newAdjectivesUnderline = !event.target.classList.contains('active');
                break;
            case 'adverb':
                setAdverbsUnderline(!event.target.classList.contains('active'));
                newAdverbsUnderline = !event.target.classList.contains('active');
                break;
            case 'verb':
                setVerbsUnderline(!event.target.classList.contains('active'));
                newVerbsUnderline = !event.target.classList.contains('active');
                break;
            case 'preposition':
                setPrepositionsUnderline(!event.target.classList.contains('active'));
                newPrepositionsUnderline = !event.target.classList.contains('active');
                break;
            case 'subconjunction':
                setSubConjunctionsUnderline(!event.target.classList.contains('active'));
                newSubConjunctionsUnderline = !event.target.classList.contains('active');
                break;
            case 'determiner':
                setDeterminersUnderline(!event.target.classList.contains('active'));
                newDeterminersUnderline = !event.target.classList.contains('active');
                break;
            case 'pronoun':
                setPronounsUnderline(!event.target.classList.contains('active'));
                newPronounsUnderline = !event.target.classList.contains('active');
                break;
            case 'conjunctions':
                setConjunctionsUnderline(!event.target.classList.contains('active'));
                newConjunctionsUnderline = !event.target.classList.contains('active');
                break;
        }
        formatText(props.analyzedText.main,
            nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, newNounsUnderline,
            adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, newAdjectivesUnderline,
            adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, newAdverbsUnderline,
            verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, newVerbsUnderline,
            prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, newPrepositionsUnderline,
            subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, newSubConjunctionsUnderline,
            determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, newDeterminersUnderline,
            pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, newPronounsUnderline,
            conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, newConjunctionsUnderline);
    }

    const colorOptions = (element: string, activeitem: string) => {
        return  <div className="color-selector">
            <span className={ 'color-item blue-violet' + (activeitem == 'blue-violet' ? ' active' : '') }
                data-element={ element } data-color="blue-violet" onClick={ setColor }></span>
            <span className={ 'color-item brown' + (activeitem == 'brown' ? ' active' : '') }
                data-element={ element } data-color="brown" onClick={ setColor }></span>
            <span className={ 'color-item coral' + (activeitem == 'coral' ? ' active' : '') }
                data-element={ element } data-color="coral" onClick={ setColor }></span>
            <span className={ 'color-item dark-blue' + (activeitem == 'dark-blue' ? ' active' : '') }
                data-element={ element } data-color="dark-blue" onClick={ setColor }></span>
            <span className={ 'color-item dark-cyan' + (activeitem == 'dark-cyan' ? ' active' : '') }
                data-element={ element } data-color="dark-cyan" onClick={ setColor }></span>
            <span className={ 'color-item crimson' + (activeitem == 'crimson' ? ' active' : '') }
                data-element={ element } data-color="crimson" onClick={ setColor }></span>
            <span className={ 'color-item dark-green' + (activeitem == 'dark-green' ? ' active' : '') }
                data-element={ element } data-color="dark-green" onClick={ setColor }></span>
            <span className={ 'color-item dark-salmon' + (activeitem == 'dark-salmon' ? ' active' : '') }
                data-element={ element } data-color="dark-salmon" onClick={ setColor }></span>
            <span className={ 'color-item dark-orange' + (activeitem == 'dark-orange' ? ' active' : '') }
                data-element={ element } data-color="dark-orange" onClick={ setColor }></span>
            <span className={ 'color-item cadet-blue' + (activeitem == 'cadet-blue' ? ' active' : '') }
                data-element={ element } data-color="cadet-blue" onClick={ setColor }></span>
            <span className={ 'color-item chocolate' + (activeitem == 'chocolate' ? ' active' : '') }
                data-element={ element } data-color="chocolate" onClick={ setColor }></span>
            <span className={ 'color-item dark-magenta' + (activeitem == 'dark-magenta' ? ' active' : '') }
                data-element={ element } data-color="dark-magenta" onClick={ setColor }></span>
        </div>;
    }

    const sizeOptions = (element: string, activeitem: string) => {
        return  <div className="size-selector">
                <span className={ 'size-item normal' + (activeitem == 'normal' ? ' active' : '') }
                    data-element={ element } data-size="normal" onClick={ setSize }>{ 'A' }</span>
                <span className={ 'size-item big' + (activeitem == 'big' ? ' active' : '') }
                    data-element={ element } data-size="big" onClick={ setSize }>{ 'A' }</span>
                <span className={ 'size-item huge' + (activeitem == 'huge' ? ' active' : '') }
                    data-element={ element } data-size="huge" onClick={ setSize }>{ 'A' }</span>
            </div>;
    }

    function decodeColor(colorcode: string) {
        switch (colorcode) {
            case 'blue-violet':
                return 'blueviolet';
            case 'brown':
                return 'brown';
            case 'coral':
                return 'coral';
            case 'dark-blue':
                return 'darkblue';
            case 'dark-cyan':
                return 'darkcyan';
            case 'crimson':
                return 'crimson';
            case 'dark-green':
                return 'darkgreen';
            case 'dark-salmon':
                return 'darksalmon';
            case 'dark-orange':
                return 'darkorange';
            case 'cadet-blue':
                return 'cadetblue';
            case 'chocolate':
                return 'chocolate';
            case 'dark-magenta':
                return 'darkmagenta';
            default:
                return '';
        }
    }

    function decodeSize(sizecode: string) {
        switch (sizecode) {
            case 'big':
                return '1.4em';
            case 'huge':
                return '1.8em';
            default:
                return '';
        }
    }

    // Helper function to check if a token has a specific feature (e.g., PronType=Art or Poss=Yes)
    function hasFeature(token: any, featureKey: string, featureValue?: string): boolean {
        if (!token.features) return false;
        const features = token.features.split('|');
        if (featureValue) {
            return features.some((f: string) => f === `${featureKey}=${featureValue}`);
        } else {
            return features.some((f: string) => f.startsWith(`${featureKey}=`));
        }
    }

    const formatText = (json: any,
        tmpNounsFilterOption: string, tmpNounsColor: string, tmpNounsSize: string, tmpNounsBold: boolean, tmpNounsItalic: boolean, tmpNounsUnderline: boolean,
        tmpAdjectivesFilterOption: string, tmpAdjectivesColor: string, tmpAdjectivesSize: string, tmpAdjectivesBold: boolean, tmpAdjectivesItalic: boolean, tmpAdjectivesUnderline: boolean,
        tmpAdverbsFilterOption: string, tmpAdverbsColor: string, tmpAdverbsSize: string, tmpAdverbsBold: boolean, tmpAdverbsItalic: boolean, tmpAdverbsUnderline: boolean,
        tmpVerbsFilterOption: string, tmpVerbsColor: string, tmpVerbsSize: string, tmpVerbsBold: boolean, tmpVerbsItalic: boolean, tmpVerbsUnderline: boolean,
        tmpPrepositionsFilterOption: string, tmpPrepositionsColor: string, tmpPrepositionsSize: string, tmpPrepositionsBold: boolean, tmpPrepositionsItalic: boolean, tmpPrepositionsUnderline: boolean,
        tmpSubConjunctionsFilterOption: string, tmpSubConjunctionsColor: string, tmpSubConjunctionsSize: string, tmpSubConjunctionsBold: boolean, tmpSubConjunctionsItalic: boolean, tmpSubConjunctionsUnderline: boolean,
        tmpDeterminersFilterOption: string, tmpDeterminersColor: string, tmpDeterminersSize: string, tmpDeterminersBold: boolean, tmpDeterminersItalic: boolean, tmpDeterminersUnderline: boolean,
        tmpPronounsFilterOption: string, tmpPronounsColor: string, tmpPronounsSize: string, tmpPronounsBold: boolean, tmpPronounsItalic: boolean, tmpPronounsUnderline: boolean,
        tmpConjunctionsFilterOption: string, tmpConjunctionsColor: string, tmpConjunctionsSize: string, tmpConjunctionsBold: boolean, tmpConjunctionsItalic: boolean, tmpConjunctionsUnderline: boolean) => {
        let resultAllText = '';
        if (json.length > 0) {
            let applyFormatToPos = false;
            let paragraphNum = json[0].paragraph;
            let sentenceNum = json[0].sentence;

            resultAllText = '<p>';
            let prevEndChar = 0;
            for (let i = 0; i < json.length; i++) {
                if (parseInt(json[i].sentence) != parseInt(sentenceNum)) {
                    resultAllText += ' ';
                    sentenceNum = json[i].sentence;
                }
                if (parseInt(json[i].paragraph) != parseInt(paragraphNum)) {
                    resultAllText += '</p><p>';
                    paragraphNum = json[i].paragraph;
                }
                if (prevEndChar != 0 && (prevEndChar < parseInt(json[i].start_char))) {
                    resultAllText += ' ';
                }
                let style = '';
                let classProps = '';
                applyFormatToPos = false;

                // Check main categories by UPOS
                if (json[i].upos === 'NOUN') {
                    // Nouns
                    if (tmpNounsFilterOption == 'all') {
                        applyFormatToPos = true;
                    } else if (tmpNounsFilterOption == 'feminine') {
                        applyFormatToPos = json[i].xpos === 'ncfs000' || json[i].xpos === 'ncfp000';
                    } else if (tmpNounsFilterOption == 'masculine') {
                        applyFormatToPos = json[i].xpos === 'ncms000' || json[i].xpos === 'ncmp000';
                    } else if (tmpNounsFilterOption == 'common') {
                        applyFormatToPos = json[i].xpos === 'nccs000' || json[i].xpos === 'nccp000';
                    } else if (tmpNounsFilterOption == 'invariable') {
                        applyFormatToPos = json[i].xpos === 'ncmn000' || json[i].xpos === 'ncfn000' || json[i].xpos === 'nccn000';
                    }
                    if (applyFormatToPos) {
                        if (tmpNounsColor) {
                            style += 'color:' + decodeColor(tmpNounsColor) + ';';
                        }
                        if (tmpNounsSize) {
                            style += 'font-size:' + decodeSize(tmpNounsSize) + ';';
                            classProps = 'text-' + tmpNounsSize;
                        }
                        if (tmpNounsBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpNounsItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpNounsUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'ADJ') {
                    // Adjectives
                    if (tmpAdjectivesFilterOption == 'all') {
                        applyFormatToPos = true;
                    } else if (tmpAdjectivesFilterOption == 'feminine') {
                        applyFormatToPos = json[i].xpos === 'AQ0FP0' || json[i].xpos === 'AQ0FS0';
                    } else if (tmpAdjectivesFilterOption == 'masculine') {
                        applyFormatToPos = json[i].xpos === 'AQ0MP0' || json[i].xpos === 'AQ0MS0';
                    } else if (tmpAdjectivesFilterOption == 'common') {
                        applyFormatToPos = json[i].xpos === 'AQ0CP0' || json[i].xpos === 'AQ0CS0';
                    } else if (tmpAdjectivesFilterOption == 'invariable') {
                        applyFormatToPos = json[i].xpos === 'AQ0CN0';
                    }
                    if (applyFormatToPos) {
                        if (tmpAdjectivesColor) {
                            style += 'color:' + decodeColor(tmpAdjectivesColor) + ';';
                        }
                        if (tmpAdjectivesSize) {
                            style += 'font-size:' + decodeSize(tmpAdjectivesSize) + ';';
                            classProps = 'text-' + tmpAdjectivesSize;
                        }
                        if (tmpAdjectivesBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpAdjectivesItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpAdjectivesUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'RG' || json[i].upos === 'RN') {
                    // Adverbs (no subcategories for Spanish)
                    if (tmpAdverbsFilterOption == 'all') {
                        applyFormatToPos = true;
                    }
                    if (applyFormatToPos) {
                        if (tmpAdverbsColor) {
                            style += 'color:' + decodeColor(tmpAdverbsColor) + ';';
                        }
                        if (tmpAdverbsSize) {
                            style += 'font-size:' + decodeSize(tmpAdverbsSize) + ';';
                            classProps = 'text-' + tmpAdverbsSize;
                        }
                        if (tmpAdverbsBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpAdverbsItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpAdverbsUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'VERB') {
                    // Verbs (no irregular category for now)
                    if (tmpVerbsFilterOption == 'all') {
                        applyFormatToPos = true;
                    }
                    if (applyFormatToPos) {
                        if (tmpVerbsColor) {
                            style += 'color:' + decodeColor(tmpVerbsColor) + ';';
                        }
                        if (tmpVerbsSize) {
                            style += 'font-size:' + decodeSize(tmpVerbsSize) + ';';
                            classProps = 'text-' + tmpVerbsSize;
                        }
                        if (tmpVerbsBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpVerbsItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpVerbsUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'ADP') {
                    // Prepositions
                    if (tmpPrepositionsFilterOption == 'all') {
                        applyFormatToPos = true;
                    }
                    if (applyFormatToPos) {
                        if (tmpPrepositionsColor) {
                            style += 'color:' + decodeColor(tmpPrepositionsColor) + ';';
                        }
                        if (tmpPrepositionsSize) {
                            style += 'font-size:' + decodeSize(tmpPrepositionsSize) + ';';
                            classProps = 'text-' + tmpPrepositionsSize;
                        }
                        if (tmpPrepositionsBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpPrepositionsItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpPrepositionsUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'SCONJ') {
                    // Subordinating Conjunctions
                    if (tmpSubConjunctionsFilterOption == 'all') {
                        applyFormatToPos = true;
                    }
                    if (applyFormatToPos) {
                        if (tmpSubConjunctionsColor) {
                            style += 'color:' + decodeColor(tmpSubConjunctionsColor) + ';';
                        }
                        if (tmpSubConjunctionsSize) {
                            style += 'font-size:' + decodeSize(tmpSubConjunctionsSize) + ';';
                            classProps = 'text-' + tmpSubConjunctionsSize;
                        }
                        if (tmpSubConjunctionsBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpSubConjunctionsItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpSubConjunctionsUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'DET') {
                    // Determiners with subcategories
                    if (tmpDeterminersFilterOption == 'all') {
                        applyFormatToPos = true;
                    } else if (tmpDeterminersFilterOption == 'articles') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Art');
                    } else if (tmpDeterminersFilterOption == 'demonstrative') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Dem');
                    } else if (tmpDeterminersFilterOption == 'possessive') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Pos');
                    } else if (tmpDeterminersFilterOption == 'indefinite') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Ind');
                    } else if (tmpDeterminersFilterOption == 'interrogative') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Int');
                    } else if (tmpDeterminersFilterOption == 'relative') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Rel');
                    } else if (tmpDeterminersFilterOption == 'numeral') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Num');
                    } else if (tmpDeterminersFilterOption == 'exclamatory') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Excl');
                    }
                    if (applyFormatToPos) {
                        if (tmpDeterminersColor) {
                            style += 'color:' + decodeColor(tmpDeterminersColor) + ';';
                        }
                        if (tmpDeterminersSize) {
                            style += 'font-size:' + decodeSize(tmpDeterminersSize) + ';';
                            classProps = 'text-' + tmpDeterminersSize;
                        }
                        if (tmpDeterminersBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpDeterminersItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpDeterminersUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'PRON') {
                    // Pronouns with subcategories
                    if (tmpPronounsFilterOption == 'all') {
                        applyFormatToPos = true;
                    } else if (tmpPronounsFilterOption == 'possessive') {
                        applyFormatToPos = hasFeature(json[i], 'Poss', 'Yes');
                    } else if (tmpPronounsFilterOption == 'demonstrative') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Dem');
                    } else if (tmpPronounsFilterOption == 'relative') {
                        applyFormatToPos = hasFeature(json[i], 'PronType', 'Rel');
                    }
                    if (applyFormatToPos) {
                        if (tmpPronounsColor) {
                            style += 'color:' + decodeColor(tmpPronounsColor) + ';';
                        }
                        if (tmpPronounsSize) {
                            style += 'font-size:' + decodeSize(tmpPronounsSize) + ';';
                            classProps = 'text-' + tmpPronounsSize;
                        }
                        if (tmpPronounsBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpPronounsItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpPronounsUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                } else if (json[i].upos === 'CCONJ') {
                    // Coordinating Conjunctions
                    if (tmpConjunctionsFilterOption == 'all') {
                        applyFormatToPos = true;
                    }
                    if (applyFormatToPos) {
                        if (tmpConjunctionsColor) {
                            style += 'color:' + decodeColor(tmpConjunctionsColor) + ';';
                        }
                        if (tmpConjunctionsSize) {
                            style += 'font-size:' + decodeSize(tmpConjunctionsSize) + ';';
                            classProps = 'text-' + tmpConjunctionsSize;
                        }
                        if (tmpConjunctionsBold) {
                            style += 'font-weight: bold;';
                        }
                        if (tmpConjunctionsItalic) {
                            style += 'font-style: italic;';
                        }
                        if (tmpConjunctionsUnderline) {
                            style += 'text-decoration: underline;';
                        }
                    }
                }
                if (applyFormatToPos) {
                    resultAllText += '<span style="' + style + '">' + json[i].word + '</span>';
                } else {
                    resultAllText += json[i].word;
                }
                prevEndChar = parseInt(json[i].end_char);
            }
            resultAllText += '</p>';
        }
        setAllText(resultAllText);
        props.saveFormattedTextCallback(resultAllText);
    }

    useEffect(() => {
        if (props.analyzedText.main && props.analyzedText.main.length == 0) {
            setProcessingEmpty(true);
        } else {
            setProcessingEmpty(false);
            const newNlpCategories = {
                // Nouns - using UPOS
                nounsAll: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN').length,
                nounsFeminine: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && (c.xpos === 'ncfs000' || c.xpos === 'ncfp000')).length,
                nounsMasculine: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && (c.xpos === 'ncms000' || c.xpos === 'ncmp000')).length,
                nounsCommon: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && (c.xpos === 'nccs000' || c.xpos === 'nccp000')).length,
                nounsInvariable: props.analyzedText.main.filter((c: any) => c.upos === 'NOUN' && (c.xpos === 'ncmn000' || c.xpos === 'ncfn000' || c.xpos === 'nccn000')).length,

                // Adjectives - using UPOS
                adjectivesAll: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ').length,
                adjectivesFeminine: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && (c.xpos === 'AQ0FP0' || c.xpos === 'AQ0FS0')).length,
                adjectivesMasculine: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && (c.xpos === 'AQ0MP0' || c.xpos === 'AQ0MS0')).length,
                adjectivesCommon: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && (c.xpos === 'AQ0CP0' || c.xpos === 'AQ0CS0')).length,
                adjectivesInvariable: props.analyzedText.main.filter((c: any) => c.upos === 'ADJ' && c.xpos === 'AQ0CN0').length,

                // Adverbs - using UPOS (no subcategories for Spanish)
                adverbsAll: props.analyzedText.main.filter((c: any) => c.upos === 'RG' || c.upos === 'RN').length,

                // Verbs - using UPOS (no irregular category for now)
                verbsAll: props.analyzedText.main.filter((c: any) => c.upos === 'VERB').length,

                // Prepositions
                prepositionsAll: props.analyzedText.main.filter((c: any) => c.upos === 'ADP').length,

                // Subordinating Conjunctions
                subConjunctionsAll: props.analyzedText.main.filter((c: any) => c.upos === 'SCONJ').length,

                // Determiners with subcategories based on features
                determinersAll: props.analyzedText.main.filter((c: any) => c.upos === 'DET').length,
                determinersArticles: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Art')).length,
                determinersDemonstrative: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Dem')).length,
                determinersPossessive: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Pos')).length,
                determinersIndefinite: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Ind')).length,
                determinersInterrogative: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Int')).length,
                determinersRelative: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Rel')).length,
                determinersNumeral: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Num')).length,
                determinersExclamatory: props.analyzedText.main.filter((c: any) => c.upos === 'DET' && hasFeature(c, 'PronType', 'Excl')).length,

                // Pronouns with subcategories based on features
                pronounsAll: props.analyzedText.main.filter((c: any) => c.upos === 'PRON').length,
                pronounsPossessive: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c, 'Poss', 'Yes')).length,
                pronounsDemonstrative: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c, 'PronType', 'Dem')).length,
                pronounsRelative: props.analyzedText.main.filter((c: any) => c.upos === 'PRON' && hasFeature(c, 'PronType', 'Rel')).length,

                // Coordinating Conjunctions
                conjunctionsAll: props.analyzedText.main.filter((c: any) => c.upos === 'CCONJ').length,
            };
            setNlpCategories(newNlpCategories);

            formatText(props.analyzedText.main,
                nounsFilterOption, nounsColor, nounsSize, nounsBold, nounsItalic, nounsUnderline,
                adjectivesFilterOption, adjectivesColor, adjectivesSize, adjectivesBold, adjectivesItalic, adjectivesUnderline,
                adverbsFilterOption, adverbsColor, adverbsSize, adverbsBold, adverbsItalic, adverbsUnderline,
                verbsFilterOption, verbsColor, verbsSize, verbsBold, verbsItalic, verbsUnderline,
                prepositionsFilterOption, prepositionsColor, prepositionsSize, prepositionsBold, prepositionsItalic, prepositionsUnderline,
                subConjunctionsFilterOption, subConjunctionsColor, subConjunctionsSize, subConjunctionsBold, subConjunctionsItalic, subConjunctionsUnderline,
                determinersFilterOption, determinersColor, determinersSize, determinersBold, determinersItalic, determinersUnderline,
                pronounsFilterOption, pronounsColor, pronounsSize, pronounsBold, pronounsItalic, pronounsUnderline,
                conjunctionsFilterOption, conjunctionsColor, conjunctionsSize, conjunctionsBold, conjunctionsItalic, conjunctionsUnderline);
        }
    }, []);

    return (
        <div className="processed-text-container">
            { processingEmpty &&
                <div className="empty-processed-text">
                    <Alert key={ 'warning' } variant={ 'warning' }>
                        { t("Sorry! The result of the text analysis is either empty or some errors were found. Revise and change your text and try it again.") }
                    </Alert>
                </div>
            }
            { !processingEmpty &&
                <div className="text-filters">
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>{ t("Word Categories") }</Accordion.Header>
                            <Accordion.Body>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (nounsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'nouns' } label={ t("Nouns") + ' (' + nlpCategories.nounsAll + ')' }
                                            onChange={ handleNounsFilterChange } checked={ nounsFilterActive } />
                                    </div>
                                    { nounsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('noun', nounsColor) }
                                                { sizeOptions('noun', nounsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (nounsBold ? ' active' : '') }
                                                        data-element="noun" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (nounsItalic ? ' active' : '') }
                                                        data-element="noun" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (nounsUnderline ? ' active' : '') }
                                                        data-element="noun" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-all' } name={ 'nouns' }
                                                    label={ t("All nouns") + ' (' + nlpCategories.nounsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleNounsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-feminine' } name={ 'nouns' }
                                                    label={ t("Feminine") + ' (' + nlpCategories.nounsFeminine + ')' } value={ 'feminine' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-masculine' } name={ 'nouns' }
                                                    label={ t("Masculine") + ' (' + nlpCategories.nounsMasculine + ')' } value={ 'masculine' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-common' } name={ 'nouns' }
                                                    label={ t("Common") + ' (' + nlpCategories.nounsCommon + ')' } value={ 'common' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'nouns-invariable' } name={ 'nouns' }
                                                    label={ t("Invariable") + ' (' + nlpCategories.nounsInvariable + ')' } value={ 'invariable' }
                                                    onChange={ handleNounsFilterOptionChange} />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (adjectivesFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'adjectives' } label={ t("Adjectives") + ' (' + nlpCategories.adjectivesAll + ')' }
                                            onChange={ handleAdjectivesFilterChange } checked={ adjectivesFilterActive }/>
                                    </div>
                                    { adjectivesFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('adjective', adjectivesColor) }
                                                { sizeOptions('adjective', adjectivesSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (adjectivesBold ? ' active' : '') }
                                                        data-element="adjective" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (adjectivesItalic ? ' active' : '') }
                                                        data-element="adjective" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (adjectivesUnderline ? ' active' : '') }
                                                        data-element="adjective" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <div className="option-switch">
                                                    <Form.Check type={ 'radio' } id={ 'adjectives-all' } name={ 'adjectives' }
                                                        label={ t("All adjectives") + ' (' + nlpCategories.adjectivesAll + ')' } value={ 'all' } defaultChecked={ true }
                                                        onChange={ handleAdjectivesFilterOptionChange } />
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <div className="option-switch">
                                                    <Form.Check type={ 'radio' } id={ 'adjectives-feminine' } name={ 'adjectives' }
                                                        label={ t("Feminine") + ' (' + nlpCategories.adjectivesFeminine + ')' } value={ 'feminine' }
                                                        onChange={ handleAdjectivesFilterOptionChange } />
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <div className="option-switch">
                                                    <Form.Check type={ 'radio' } id={ 'adjectives-masculine' } name={ 'adjectives' }
                                                        label={ t("Masculine") + ' (' + nlpCategories.adjectivesMasculine + ')' } value={ 'masculine' }
                                                        onChange={ handleAdjectivesFilterOptionChange } />
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <div className="option-switch">
                                                    <Form.Check type={ 'radio' } id={ 'adjectives-common' } name={ 'adjectives' }
                                                        label={ t("Common") + ' (' + nlpCategories.adjectivesCommon + ')' } value={ 'common' }
                                                        onChange={ handleAdjectivesFilterOptionChange } />
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <div className="option-switch">
                                                    <Form.Check type={ 'radio' } id={ 'adjectives-invariable' } name={ 'adjectives' }
                                                        label={ t("Invariable") + ' (' + nlpCategories.adjectivesInvariable + ')' } value={ 'invariable' }
                                                        onChange={ handleAdjectivesFilterOptionChange } />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (adverbsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'adverbs' } label={ t("Adverbs") + ' (' + nlpCategories.adverbsAll + ')' }
                                            onChange={ handleAdverbsFilterChange } checked={ adverbsFilterActive }/>
                                    </div>
                                    { adverbsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('adverb', adverbsColor) }
                                                { sizeOptions('adverb', adverbsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (adverbsBold ? ' active' : '') }
                                                        data-element="adverb" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (adverbsItalic ? ' active' : '') }
                                                        data-element="adverb" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (adverbsUnderline ? ' active' : '') }
                                                        data-element="adverb" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'adverbs-all' } name={ 'adverbs' }
                                                    label={ t("All adverbs") + ' (' + nlpCategories.adverbsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleAdverbsFilterOptionChange } />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className="option-item">
                                        <div className={ 'word-category-switch' + (verbsFilterActive ? ' active' : '')}>
                                            <Form.Check type={ 'checkbox' } id={ 'verbs' } label={ t("Verbs") + ' (' + nlpCategories.verbsAll + ')' }
                                                onChange={ handleVerbsFilterChange } checked={ verbsFilterActive }/>
                                        </div>
                                        { verbsFilterActive &&
                                            <div className="options">
                                                <div className="format-options">
                                                    { colorOptions('verb', verbsColor) }
                                                    { sizeOptions('verb', verbsSize) }
                                                    <div className="other-formats">
                                                        <span className={ 'bold' + (verbsBold ? ' active' : '') }
                                                            data-element="verb" onClick={ setBold }></span>
                                                        <span className={ 'italic' + (verbsItalic ? ' active' : '') }
                                                            data-element="verb" onClick={ setItalic }></span>
                                                        <span className={ 'underline' + (verbsUnderline ? ' active' : '') }
                                                            data-element="verb" onClick={ setUnderline }></span>
                                                    </div>
                                                </div>
                                                <div className="option-item">
                                                    <Form.Check type={ 'radio' } id={ 'verbs-all' } name={ 'verbs' }
                                                        label={ t("All verbs") + ' (' + nlpCategories.verbsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                        onChange={ handleVerbsFilterOptionChange } />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (prepositionsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'prepositions' } label={ t("Prepositions") + ' (' + nlpCategories.prepositionsAll + ')' }
                                            onChange={ handlePrepositionsFilterChange } checked={ prepositionsFilterActive }/>
                                    </div>
                                    { prepositionsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('preposition', prepositionsColor) }
                                                { sizeOptions('preposition', prepositionsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (prepositionsBold ? ' active' : '') }
                                                        data-element="preposition" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (prepositionsItalic ? ' active' : '') }
                                                        data-element="preposition" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (prepositionsUnderline ? ' active' : '') }
                                                        data-element="preposition" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (subConjunctionsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'subconjunctions' } label={ t("Subordinating Conjunctions") + ' (' + nlpCategories.subConjunctionsAll + ')' }
                                            onChange={ handleSubConjunctionsFilterChange } checked={ subConjunctionsFilterActive }/>
                                    </div>
                                    { subConjunctionsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('subconjunction', subConjunctionsColor) }
                                                { sizeOptions('subconjunction', subConjunctionsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (subConjunctionsBold ? ' active' : '') }
                                                        data-element="subconjunction" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (subConjunctionsItalic ? ' active' : '') }
                                                        data-element="subconjunction" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (subConjunctionsUnderline ? ' active' : '') }
                                                        data-element="subconjunction" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (determinersFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'determiners' } label={ t("Determiners") + ' (' + nlpCategories.determinersAll + ')' }
                                            onChange={ handleDeterminersFilterChange } checked={ determinersFilterActive }/>
                                    </div>
                                    { determinersFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('determiner', determinersColor) }
                                                { sizeOptions('determiner', determinersSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (determinersBold ? ' active' : '') }
                                                        data-element="determiner" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (determinersItalic ? ' active' : '') }
                                                        data-element="determiner" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (determinersUnderline ? ' active' : '') }
                                                        data-element="determiner" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-all' } name={ 'determiners' }
                                                    label={ t("All determiners") + ' (' + nlpCategories.determinersAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-articles' } name={ 'determiners' }
                                                    label={ t("Articles") + ' (' + nlpCategories.determinersArticles + ')' } value={ 'articles' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-demonstrative' } name={ 'determiners' }
                                                    label={ t("Demonstrative") + ' (' + nlpCategories.determinersDemonstrative + ')' } value={ 'demonstrative' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-possessive' } name={ 'determiners' }
                                                    label={ t("Possessive") + ' (' + nlpCategories.determinersPossessive + ')' } value={ 'possessive' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-indefinite' } name={ 'determiners' }
                                                    label={ t("Indefinite") + ' (' + nlpCategories.determinersIndefinite + ')' } value={ 'indefinite' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-interrogative' } name={ 'determiners' }
                                                    label={ t("Interrogative") + ' (' + nlpCategories.determinersInterrogative + ')' } value={ 'interrogative' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-relative' } name={ 'determiners' }
                                                    label={ t("Relative") + ' (' + nlpCategories.determinersRelative + ')' } value={ 'relative' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-numeral' } name={ 'determiners' }
                                                    label={ t("Numeral") + ' (' + nlpCategories.determinersNumeral + ')' } value={ 'numeral' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'determiners-exclamatory' } name={ 'determiners' }
                                                    label={ t("Exclamatory") + ' (' + nlpCategories.determinersExclamatory + ')' } value={ 'exclamatory' }
                                                    onChange={ handleDeterminersFilterOptionChange } />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (pronounsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'pronouns' } label={ t("Pronouns") + ' (' + nlpCategories.pronounsAll + ')' }
                                            onChange={ handlePronounsFilterChange } checked={ pronounsFilterActive }/>
                                    </div>
                                    { pronounsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('pronoun', pronounsColor) }
                                                { sizeOptions('pronoun', pronounsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (pronounsBold ? ' active' : '') }
                                                        data-element="pronoun" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (pronounsItalic ? ' active' : '') }
                                                        data-element="pronoun" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (pronounsUnderline ? ' active' : '') }
                                                        data-element="pronoun" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pronouns-all' } name={ 'pronouns' }
                                                    label={ t("All pronouns") + ' (' + nlpCategories.pronounsAll + ')' } value={ 'all' } defaultChecked={ true }
                                                    onChange={ handlePronounsFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pronouns-possessive' } name={ 'pronouns' }
                                                    label={ t("Possessive") + ' (' + nlpCategories.pronounsPossessive + ')' } value={ 'possessive' }
                                                    onChange={ handlePronounsFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pronouns-demonstrative' } name={ 'pronouns' }
                                                    label={ t("Demonstrative") + ' (' + nlpCategories.pronounsDemonstrative + ')' } value={ 'demonstrative' }
                                                    onChange={ handlePronounsFilterOptionChange } />
                                            </div>
                                            <div className="option-item">
                                                <Form.Check type={ 'radio' } id={ 'pronouns-relative' } name={ 'pronouns' }
                                                    label={ t("Relative") + ' (' + nlpCategories.pronounsRelative + ')' } value={ 'relative' }
                                                    onChange={ handlePronounsFilterOptionChange } />
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className="word-category">
                                    <div className={ 'word-category-switch' + (conjunctionsFilterActive ? ' active' : '')}>
                                        <Form.Check type={ 'checkbox' } id={ 'conjunctions' } label={ t("Coordinating Conjunctions") + ' (' + nlpCategories.conjunctionsAll + ')' }
                                            onChange={ handleConjunctionsFilterChange } checked={ conjunctionsFilterActive }/>
                                    </div>
                                    { conjunctionsFilterActive &&
                                        <div className="options">
                                            <div className="format-options">
                                                { colorOptions('conjunctions', conjunctionsColor) }
                                                { sizeOptions('conjunctions', conjunctionsSize) }
                                                <div className="other-formats">
                                                    <span className={ 'bold' + (conjunctionsBold ? ' active' : '') }
                                                        data-element="conjunctions" onClick={ setBold }></span>
                                                    <span className={ 'italic' + (conjunctionsItalic ? ' active' : '') }
                                                        data-element="conjunctions" onClick={ setItalic }></span>
                                                    <span className={ 'underline' + (conjunctionsUnderline ? ' active' : '') }
                                                        data-element="conjunctions" onClick={ setUnderline }></span>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            }
            <div className="text-presentation">
                <div className="text-formatted">
                    { parse(allText)}
                </div>
            </div>
        </div>
    );
}
